var React = require('react');

function Globe (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M4.68359 12H27.3167","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M4.68359 20H27.3166","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":2}),React.createElement("path",{"d":"M16 27.676C18.7614 27.676 21 22.4477 21 15.9982C21 9.54867 18.7614 4.32031 16 4.32031C13.2386 4.32031 11 9.54867 11 15.9982C11 22.4477 13.2386 27.676 16 27.676Z","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":3})]);
}

Globe.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Globe;

Globe.default = Globe;
